// // src/app/modules/Members/pages/MemberDetails.jsx
// import React, { useEffect, useState, useRef } from 'react';
// import { useDispatch } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';
// import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
// import { Tabs, Tab } from 'react-bootstrap';
// import { EditMemberModal } from '../components/EditMemberModal';
// import { ConfirmActionModal } from '../../../../components/ConfirmActionModal';
// import { 
//   ArrowLeft, 
//   User, 
//   Mail, 
//   Phone, 
//   Shield, 
//   Calendar,
//   Clock,
//   UserX,
//   UserCheck,
//   Trash2,
//   MapPin
// } from 'lucide-react';
// import Moment from 'moment';
// import './member-details.scss';

// export function MemberDetails() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const isMountedRef = useRef(true);
  
  
  
//   const [loading, setLoading] = useState(false);
//   const [memberData, setMemberData] = useState(null);
//   const [activeTab, setActiveTab] = useState('overview');
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showSuspendModal, setShowSuspendModal] = useState(false);
//   const [showReactivateModal, setShowReactivateModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);

//   useEffect(() => {
//     isMountedRef.current = true;
    
//     if (id) {
//       fetchMemberDetails();
//     }

//     return () => {
//       isMountedRef.current = false;
//     };
//   }, [id]);

//   async function fetchMemberDetails() {
//     if (!isMountedRef.current) return;
    
//     setLoading(true);
//     try {
//       const data = await dispatch(actions.fetchAllData('member', id));
      
//       if (isMountedRef.current) {
//         setMemberData(data);
//       }
//     } catch (error) {
//       console.error('Error fetching member details:', error);
//     } finally {
//       if (isMountedRef.current) {
//         setLoading(false);
//       }
//     }
//   }

//   async function handleSuspendConfirm() {
//     setActionLoading(true);
//     try {
//       await dispatch(actions.addData('suspend_member', { membership_id: id }));
//       await fetchMemberDetails();
//       setShowSuspendModal(false);
//     } catch (error) {
//       console.error('Error suspending member:', error);
//     } finally {
//       setActionLoading(false);
//     }
//   }

//   async function handleReactivateConfirm() {
//     setActionLoading(true);
//     try {
//       await dispatch(actions.addData('reactivate_member', { membership_id: id }));
//       await fetchMemberDetails();
//       setShowReactivateModal(false);
//     } catch (error) {
//       console.error('Error reactivating member:', error);
//     } finally {
//       setActionLoading(false);
//     }
//   }

//   async function handleDeleteConfirm() {
//     setActionLoading(true);
//     try {
//       await dispatch(actions.addData('delete_member', { membership_id: id }));
//       navigate('/members');
//     } catch (error) {
//       console.error('Error deleting member:', error);
//       setActionLoading(false);
//     }
//   }

//   if (loading) {
//     return (
//       <div className="member-details-page">
//         <div className="loading-container">
//           <div className="spinner-border text-primary" role="status">
//             <span className="sr-only">Loading...</span>
//           </div>
//           <p className="mt-3 text-muted">Loading member details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!memberData) {
//     return (
//       <div className="member-details-page">
//         <div className="empty-container">
//           <User size={64} className="text-muted mb-4" />
//           <h4>Member not found</h4>
//           <p className="text-muted mb-4">This member may have been removed or doesn't exist.</p>
//           <button className="btn btn-primary" onClick={() => navigate('/members')}>
//             <ArrowLeft size={16} className="mr-2" />
//             Back to Members
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const { user } = memberData;

//   return (
//     <>
//       <div className="member-details-page">
//         {/* Header */}
//         <div className="page-header">
//           <button className="btn-back" onClick={() => navigate('/members')}>
//             <ArrowLeft size={20} />
//           </button>
//           <div className="header-content">
//             <div className="breadcrumb">
//               <span className="breadcrumb-item">Members</span>
//               <span className="breadcrumb-separator">/</span>
//               <span className="breadcrumb-item active">
//                 {user?.first_name} {user?.last_name}
//               </span>
//             </div>
//             <h1 className="page-title">Member Profile</h1>
//           </div>
//         </div>

//         <div className="row g-4">
//           {/* Left Column - Profile Card */}
//           <div className="col-lg-4">
//             <div className="profile-card">
//               {/* Avatar & Basic Info */}
//               <div className="profile-header">
//                 <div className="avatar-wrapper">
//                   <div className="avatar">
//                     <User size={48} />
//                   </div>
//                 </div>
                
//                 <h2 className="profile-name">
//                   {user?.first_name} {user?.last_name}
//                 </h2>
                
//                 <div className="profile-role">
//                   {memberData.role?.charAt(0).toUpperCase() + memberData.role?.slice(1)}
//                 </div>
                
//                 <span className={`status-badge status-${memberData.status}`}>
//                   {memberData.status?.toUpperCase()}
//                 </span>
//               </div>

//               {/* Contact Info */}
//               <div className="info-section">
//                 <h3 className="section-title">Contact Information</h3>
//                 <div className="info-list">
//                   {user?.email && (
//                     <div className="info-item">
//                       <Mail size={18} className="info-icon" />
//                       <span className="info-text">{user.email}</span>
//                     </div>
//                   )}
//                   {user?.phone_number && (
//                     <div className="info-item">
//                       <Phone size={18} className="info-icon" />
//                       <span className="info-text">{user.phone_number}</span>
//                     </div>
//                   )}
//                   {user?.address && (
//                     <div className="info-item">
//                       <MapPin size={18} className="info-icon" />
//                       <span className="info-text">{user.address}</span>
//                     </div>
//                   )}
//                   {!user?.email && !user?.phone_number && !user?.address && (
//                     <div className="empty-message">No contact information available</div>
//                   )}
//                 </div>
//               </div>

//               {/* Membership Info */}
//               <div className="info-section">
//                 <h3 className="section-title">Membership Details</h3>
//                 <div className="info-grid">
//                   <div className="info-card">
//                     <Calendar size={18} className="info-card-icon" />
//                     <div className="info-card-content">
//                       <div className="info-card-label">Joined</div>
//                       <div className="info-card-value">
//                         {Moment(memberData.joined_at).format('MMM DD, YYYY')}
//                       </div>
//                     </div>
//                   </div>
                  
//                   <div className="info-card">
//                     <Clock size={18} className="info-card-icon" />
//                     <div className="info-card-content">
//                       <div className="info-card-label">Member For</div>
//                       <div className="info-card-value">
//                         {Moment(memberData.joined_at).fromNow(true)}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="action-section">
//                 {/* <button 
//                   className="action-btn action-btn-primary"
//                   onClick={() => setShowEditModal(true)}
//                 >
//                   <Edit size={18} />
//                   <span>Edit Member</span>
//                 </button>
//                  */}
//                 {memberData.status === 'active' ? (
//                   <button 
//                     className="action-btn action-btn-warning"
//                     onClick={() => setShowSuspendModal(true)}
//                   >
//                     <UserX size={18} />
//                     <span>Suspend Member</span>
//                   </button>
//                 ) : (
//                   <button 
//                     className="action-btn action-btn-success"
//                     onClick={() => setShowReactivateModal(true)}
//                   >
//                     <UserCheck size={18} />
//                     <span>Reactivate Member</span>
//                   </button>
//                 )}
                
//                 <button 
//                   className="action-btn action-btn-danger"
//                   onClick={() => setShowDeleteModal(true)}
//                 >
//                   <Trash2 size={18} />
//                   <span>Remove Member</span>
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Details Tabs */}
//           <div className="col-lg-8">
//             <div className="details-card">
//               <Tabs activeKey={activeTab} onSelect={setActiveTab} className="details-tabs">
//                 {/* Overview Tab */}
//                 <Tab eventKey="overview" title="Overview">
//                   <div className="tab-content-wrapper">
//                     {/* Role Section */}
//                     <div className="detail-section">
//                       <div className="detail-header">
//                         <Shield size={20} />
//                         <h3>Role & Responsibilities</h3>
//                       </div>
//                       <div className="role-display">
//                         <div className="role-badge-large">
//                           {memberData.role?.toUpperCase()}
//                         </div>
//                         <p className="role-description">
//                           {getRoleDescription(memberData.role)}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Permissions Section */}
//                     {/* <div className="detail-section">
//                       <div className="detail-header">
//                         <Key size={20} />
//                         <h3>Permissions ({memberData.permissions?.length || 0})</h3>
//                       </div>
//                       {memberData.permissions && memberData.permissions.length > 0 ? (
//                         <div className="permissions-grid">
//                           {memberData.permissions.map((permission, idx) => (
//                             <div key={idx} className="permission-chip">
//                               {formatPermission(permission)}
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <div className="empty-message">
//                           No permissions assigned to this member
//                         </div>
//                       )}
//                     </div> */}

//                     {/* Additional User Info */}
//                     {user && (
//                       <div className="detail-section">
//                         <div className="detail-header">
//                           <User size={20} />
//                           <h3>Additional Information</h3>
//                         </div>
//                         <div className="info-grid-2col">
//                           {user.user_type && (
//                             <div className="info-box">
//                               <div className="info-box-label">User Type</div>
//                               <div className="info-box-value">{user.user_type}</div>
//                             </div>
//                           )}
//                           {user.created_at && (
//                             <div className="info-box">
//                               <div className="info-box-label">Account Created</div>
//                               <div className="info-box-value">
//                                 {Moment(user.created_at).format('MMMM DD, YYYY')}
//                               </div>
//                             </div>
//                           )}
//                           <div className="info-box">
//                             <div className="info-box-label">Account Status</div>
//                             <div className="info-box-value">
//                               <span className={`status-badge status-${user.is_active ? 'active' : 'inactive'}`}>
//                                 {user.is_active ? 'Active' : 'Inactive'}
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </Tab>

//                 {/* Activity Tab */}
//                 <Tab eventKey="activity" title="Activity">
//                   <div className="tab-content-wrapper">
//                     <div className="empty-state">
//                       <Clock size={56} className="empty-icon" />
//                       <h4 className="empty-title">Activity History</h4>
//                       <p className="empty-text">
//                         Activity tracking and history logs will be available here soon
//                       </p>
//                     </div>
//                   </div>
//                 </Tab>
//               </Tabs>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       <EditMemberModal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         member={memberData}
//         onSuccess={fetchMemberDetails}
//       />

//       <ConfirmActionModal
//         show={showSuspendModal}
//         onHide={() => setShowSuspendModal(false)}
//         onConfirm={handleSuspendConfirm}
//         title="Suspend Member"
//         message={
//           <div>
//             <p>Are you sure you want to suspend <strong>{user?.first_name} {user?.last_name}</strong>?</p>
//             <p className="mt-2">They will lose access to the organization but can be reactivated later.</p>
//           </div>
//         }
//         confirmText="Suspend Member"
//         type="warning"
//         loading={actionLoading}
//       />

//       <ConfirmActionModal
//         show={showReactivateModal}
//         onHide={() => setShowReactivateModal(false)}
//         onConfirm={handleReactivateConfirm}
//         title="Reactivate Member"
//         message={
//           <div>
//             <p>Reactivate <strong>{user?.first_name} {user?.last_name}</strong>?</p>
//             <p className="mt-2">They will regain access to the organization with their previous permissions.</p>
//           </div>
//         }
//         confirmText="Reactivate"
//         type="success"
//         loading={actionLoading}
//       />

//       <ConfirmActionModal
//         show={showDeleteModal}
//         onHide={() => setShowDeleteModal(false)}
//         onConfirm={handleDeleteConfirm}
//         title="Remove Member"
//         message={
//           <div>
//             <p>Are you sure you want to permanently remove <strong>{user?.first_name} {user?.last_name}</strong>?</p>
//             <p className="mt-2 text-danger"><strong>This action cannot be undone.</strong> They will be completely removed from the organization.</p>
//           </div>
//         }
//         confirmText="Remove Member"
//         type="danger"
//         loading={actionLoading}
//       />
//     </>
//   );
// }

// // Helper functions
// function getRoleDescription(role) {
//   const descriptions = {
//     admin: 'Full access to all organization features and settings. Can manage users, access codes, and view all analytics.',
//     manager: 'Can manage access codes, view logs and analytics, and handle day-to-day operations.',
//     security: 'Focused on security operations including code validation, emergency response, and monitoring.',
//     staff: 'Can generate and validate access codes, and view basic logs.',
//     member: 'Basic access to validate codes and view logs.',
//   };
//   return descriptions[role] || 'Standard member access';
// }

// function formatPermission(permission) {
//   return permission
//     .split('_')
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ');
// }



// src/app/modules/Members/pages/StaffMemberDetails.jsx
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { Tabs, Tab } from 'react-bootstrap';
import { ConfirmActionModal } from '../../../../components/ConfirmActionModal';
import { 
  ArrowLeft, 
  User, 
  Mail, 
  Phone, 
  Shield, 
  Calendar,
  Clock,
  UserX,
  UserCheck,
  Trash2,
  MapPin,
  Briefcase,
  TrendingUp,
  Activity,
  Clock3,
  Coffee,
  Award,
  AlertCircle,
  CheckCircle,
  XCircle,
  Timer,
  Building2,
  Users,
  BarChart3
} from 'lucide-react';
import Moment from 'moment';
import './member-details.scss';

export function MemberDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isMountedRef = useRef(true);
  
  const [loading, setLoading] = useState(false);
  const [memberData, setMemberData] = useState(null);
  const [staffStats, setStaffStats] = useState(null);
  const [recentShifts, setRecentShifts] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    isMountedRef.current = true;
    
    if (id) {
      fetchMemberDetails();
      fetchStaffStats();
      fetchRecentShifts();
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [id]);

  async function fetchMemberDetails() {
    if (!isMountedRef.current) return;
    
    setLoading(true);
    try {
      const data = await dispatch(actions.fetchAllData('member', id));
      
      if (isMountedRef.current) {
        setMemberData(data);
      }
    } catch (error) {
      console.error('Error fetching member details:', error);
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }

  async function fetchStaffStats() {
    try {
      // Fetch staff performance statistics
      const stats = await dispatch(actions.fetchData('staff_stats', { 
        staff_id: id,
        period: 'month' 
      }));
      
      if (isMountedRef.current) {
        setStaffStats(stats);
      }
    } catch (error) {
      console.error('Error fetching staff stats:', error);
    }
  }

  async function fetchRecentShifts() {
    try {
      const shifts = await dispatch(actions.fetchData('staff_shifts', { 
        staff_id: id,
        limit: 10 
      }));
      
      if (isMountedRef.current) {
        setRecentShifts(shifts?.shifts || []);
      }
    } catch (error) {
      console.error('Error fetching recent shifts:', error);
    }
  }

  async function handleSuspendConfirm() {
    setActionLoading(true);
    try {
      await dispatch(actions.addData('suspend_member', { membership_id: id }));
      await fetchMemberDetails();
      setShowSuspendModal(false);
    } catch (error) {
      console.error('Error suspending member:', error);
    } finally {
      setActionLoading(false);
    }
  }

  async function handleReactivateConfirm() {
    setActionLoading(true);
    try {
      await dispatch(actions.addData('reactivate_member', { membership_id: id }));
      await fetchMemberDetails();
      setShowReactivateModal(false);
    } catch (error) {
      console.error('Error reactivating member:', error);
    } finally {
      setActionLoading(false);
    }
  }

  async function handleDeleteConfirm() {
    setActionLoading(true);
    try {
      await dispatch(actions.addData('delete_member', { membership_id: id }));
      navigate('/members');
    } catch (error) {
      console.error('Error deleting member:', error);
      setActionLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="staff-member-details-page">
        <div className="loading-container">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-3">Loading staff member details...</p>
        </div>
      </div>
    );
  }

  if (!memberData) {
    return (
      <div className="staff-member-details-page">
        <div className="empty-container">
          <User size={64} className="mb-4" />
          <h4>Staff Member Not Found</h4>
          <p className="mb-4">This staff member may have been removed or doesn't exist.</p>
          <button className="btn btn-primary" onClick={() => navigate('/members')}>
            <ArrowLeft size={16} className="me-2" />
            Back to Members
          </button>
        </div>
      </div>
    );
  }

  const { user } = memberData;
  const isStaff = memberData.role === 'staff';

  return (
    <>
      <div className="staff-member-details-page">
        {/* Header */}
        <div className="page-header">
          <button className="btn-back" onClick={() => navigate('/members')}>
            <ArrowLeft size={20} />
          </button>
          <div className="header-content">
            <div className="breadcrumb">
              <span className="breadcrumb-item">Members</span>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-item">Staff</span>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-item active">
                {user?.first_name} {user?.last_name}
              </span>
            </div>
            <h1 className="page-title">Staff Member Profile</h1>
          </div>
        </div>

        <div className="content-wrapper">
          {/* Top Stats Bar - Only for Staff */}
          {isStaff && (
            <div className="stats-bar">
              <div className="stat-card">
                <div className="stat-icon" style={{ background: '#EEF6FF' }}>
                  <Clock3 size={20} style={{ color: '#3B82F6' }} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Hours</div>
                  <div className="stat-value">{staffStats?.total_hours || 0}h</div>
                  <div className="stat-change positive">This month</div>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ background: '#F0FDF4' }}>
                  <CheckCircle size={20} style={{ color: '#10B981' }} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">On-Time Rate</div>
                  <div className="stat-value">{staffStats?.on_time_percentage || 0}%</div>
                  <div className="stat-change positive">
                    {staffStats?.on_time_shifts || 0} of {staffStats?.total_shifts || 0} shifts
                  </div>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ background: '#FFFBEB' }}>
                  <AlertCircle size={20} style={{ color: '#F59E0B' }} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Late Arrivals</div>
                  <div className="stat-value">{staffStats?.late_arrivals || 0}</div>
                  <div className="stat-change neutral">This month</div>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ background: '#FFF1F2' }}>
                  <Coffee size={20} style={{ color: '#F43F5E' }} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Avg Break Time</div>
                  <div className="stat-value">{staffStats?.avg_break_minutes || 0}m</div>
                  <div className="stat-change neutral">Per shift</div>
                </div>
              </div>
            </div>
          )}

          {/* Main Content Grid */}
          <div className="main-grid">
            {/* Left Column - Profile Info */}
            <div className="profile-column">
              <div className="profile-card">
                {/* Avatar & Basic Info */}
                <div className="profile-header">
                  <div className="avatar-wrapper">
                    <div className="avatar">
                      <User size={40} />
                    </div>
                    <span className={`status-indicator status-${memberData.status}`}></span>
                  </div>
                  
                  <h2 className="profile-name">
                    {user?.first_name} {user?.last_name}
                  </h2>
                  
                  <div className="profile-meta">
                    <span className="role-badge">
                      {memberData.role?.charAt(0).toUpperCase() + memberData.role?.slice(1)}
                    </span>
                    <span className={`status-badge status-${memberData.status}`}>
                      {memberData.status?.toUpperCase()}
                    </span>
                  </div>
                </div>

                {/* Quick Info Cards */}
                <div className="info-cards">
                  {memberData.employee_id && (
                    <div className="info-card">
                      <div className="info-card-label">Employee ID</div>
                      <div className="info-card-value">{memberData.employee_id}</div>
                    </div>
                  )}
                  
                  {memberData.department && (
                    <div className="info-card">
                      <div className="info-card-label">Department</div>
                      <div className="info-card-value">{memberData.department}</div>
                    </div>
                  )}
                  
                  <div className="info-card">
                    <div className="info-card-label">Joined</div>
                    <div className="info-card-value">
                      {Moment(memberData.joined_at).format('MMM DD, YYYY')}
                    </div>
                  </div>
                  
                  <div className="info-card">
                    <div className="info-card-label">Member For</div>
                    <div className="info-card-value">
                      {Moment(memberData.joined_at).fromNow(true)}
                    </div>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="info-section">
                  <h3 className="section-title">Contact Information</h3>
                  <div className="info-list">
                    {user?.email && (
                      <div className="info-item">
                        <Mail size={16} className="info-icon" />
                        <span className="info-text">{user.email}</span>
                      </div>
                    )}
                    {user?.phone_number && (
                      <div className="info-item">
                        <Phone size={16} className="info-icon" />
                        <span className="info-text">{user.phone_number}</span>
                      </div>
                    )}
                    {user?.address && (
                      <div className="info-item">
                        <MapPin size={16} className="info-icon" />
                        <span className="info-text">{user.address}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  {memberData.status === 'active' ? (
                    <button 
                      className="action-btn action-btn-warning"
                      onClick={() => setShowSuspendModal(true)}
                    >
                      <UserX size={18} />
                      <span>Suspend</span>
                    </button>
                  ) : (
                    <button 
                      className="action-btn action-btn-success"
                      onClick={() => setShowReactivateModal(true)}
                    >
                      <UserCheck size={18} />
                      <span>Reactivate</span>
                    </button>
                  )}
                  
                  <button 
                    className="action-btn action-btn-danger"
                    onClick={() => setShowDeleteModal(true)}
                  >
                    <Trash2 size={18} />
                    <span>Remove</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - Detailed Information */}
            <div className="details-column">
              <div className="details-card">
                <Tabs 
                  activeKey={activeTab} 
                  onSelect={setActiveTab} 
                  className="custom-tabs"
                >
                  {/* Overview Tab */}
                  <Tab eventKey="overview" title={
                    <span className="tab-title">
                      <Activity size={16} />
                      Overview
                    </span>
                  }>
                    <div className="tab-content-area">
                      {/* Performance Summary - Staff Only */}
                      {isStaff && (
                        <div className="detail-section">
                          <div className="section-header">
                            <TrendingUp size={18} />
                            <h3>Performance Summary</h3>
                          </div>
                          <div className="performance-grid">
                            <div className="performance-card">
                              <div className="performance-icon success">
                                <CheckCircle size={20} />
                              </div>
                              <div className="performance-content">
                                <div className="performance-value">
                                  {staffStats?.total_shifts || 0}
                                </div>
                                <div className="performance-label">Total Shifts</div>
                              </div>
                            </div>

                            <div className="performance-card">
                              <div className="performance-icon primary">
                                <Timer size={20} />
                              </div>
                              <div className="performance-content">
                                <div className="performance-value">
                                  {staffStats?.overtime_hours || 0}h
                                </div>
                                <div className="performance-label">Overtime</div>
                              </div>
                            </div>

                            <div className="performance-card">
                              <div className="performance-icon warning">
                                <Coffee size={20} />
                              </div>
                              <div className="performance-content">
                                <div className="performance-value">
                                  {staffStats?.total_breaks || 0}
                                </div>
                                <div className="performance-label">Total Breaks</div>
                              </div>
                            </div>

                            <div className="performance-card">
                              <div className="performance-icon info">
                                <Award size={20} />
                              </div>
                              <div className="performance-content">
                                <div className="performance-value">
                                  {staffStats?.attendance_score || 0}%
                                </div>
                                <div className="performance-label">Attendance Score</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Work Details - Staff Only */}
                      {isStaff && (
                        <div className="detail-section">
                          <div className="section-header">
                            <Briefcase size={18} />
                            <h3>Work Details</h3>
                          </div>
                          <div className="detail-grid">
                            {memberData.shift_start && memberData.shift_end && (
                              <div className="detail-box">
                                <div className="detail-label">Scheduled Shift</div>
                                <div className="detail-value">
                                  {Moment(memberData.shift_start, 'HH:mm').format('h:mm A')} - {Moment(memberData.shift_end, 'HH:mm').format('h:mm A')}
                                </div>
                              </div>
                            )}

                            {memberData.manager_name && (
                              <div className="detail-box">
                                <div className="detail-label">Reports To</div>
                                <div className="detail-value">{memberData.manager_name}</div>
                              </div>
                            )}

                            {memberData.space_name && (
                              <div className="detail-box">
                                <div className="detail-label">Assigned Location</div>
                                <div className="detail-value">{memberData.space_name}</div>
                              </div>
                            )}

                            <div className="detail-box">
                              <div className="detail-label">Work Type</div>
                              <div className="detail-value">
                                {memberData.is_scheduled_shift ? 'Scheduled' : 'Flexible'}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Role & Permissions */}
                      <div className="detail-section">
                        <div className="section-header">
                          <Shield size={18} />
                          <h3>Role & Responsibilities</h3>
                        </div>
                        <div className="role-info">
                          <div className="role-badge-large">
                            {memberData.role?.toUpperCase()}
                          </div>
                          <p className="role-description">
                            {getRoleDescription(memberData.role)}
                          </p>
                        </div>
                      </div>

                      {/* Account Information */}
                      <div className="detail-section">
                        <div className="section-header">
                          <User size={18} />
                          <h3>Account Information</h3>
                        </div>
                        <div className="detail-grid">
                          {user?.user_type && (
                            <div className="detail-box">
                              <div className="detail-label">User Type</div>
                              <div className="detail-value">{user.user_type}</div>
                            </div>
                          )}
                          
                          {user?.created_at && (
                            <div className="detail-box">
                              <div className="detail-label">Account Created</div>
                              <div className="detail-value">
                                {Moment(user.created_at).format('MMM DD, YYYY')}
                              </div>
                            </div>
                          )}
                          
                          <div className="detail-box">
                            <div className="detail-label">Account Status</div>
                            <div className="detail-value">
                              <span className={`status-badge status-${user?.is_active ? 'active' : 'inactive'}`}>
                                {user?.is_active ? 'Active' : 'Inactive'}
                              </span>
                            </div>
                          </div>

                          <div className="detail-box">
                            <div className="detail-label">Last Active</div>
                            <div className="detail-value">
                              {user?.last_login ? Moment(user.last_login).fromNow() : 'Never'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>

                  {/* Attendance Tab - Staff Only */}
                  {isStaff && (
                    <Tab eventKey="attendance" title={
                      <span className="tab-title">
                        <Clock size={16} />
                        Attendance
                      </span>
                    }>
                      <div className="tab-content-area">
                        <div className="detail-section">
                          <div className="section-header">
                            <BarChart3 size={18} />
                            <h3>Recent Shifts</h3>
                          </div>
                          
                          {recentShifts.length > 0 ? (
                            <div className="shifts-list">
                              {recentShifts.map((shift, idx) => (
                                <div key={shift.log_id || idx} className="shift-item">
                                  <div className="shift-date">
                                    <div className="shift-day">
                                      {Moment(shift.entry_time).format('DD')}
                                    </div>
                                    <div className="shift-month">
                                      {Moment(shift.entry_time).format('MMM')}
                                    </div>
                                  </div>
                                  
                                  <div className="shift-details">
                                    <div className="shift-time">
                                      <Clock3 size={14} />
                                      {Moment(shift.entry_time).format('h:mm A')} - {shift.exit_time ? Moment(shift.exit_time).format('h:mm A') : 'Ongoing'}
                                    </div>
                                    <div className="shift-meta">
                                      <span className="shift-duration">
                                        {shift.worked_hours ? `${shift.worked_hours.toFixed(1)}h worked` : 'In progress'}
                                      </span>
                                      {shift.break_logs && shift.break_logs.length > 0 && (
                                        <span className="shift-breaks">
                                          • {shift.break_logs.length} break(s)
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  
                                  <div className="shift-status">
                                    <span className={`shift-status-badge status-${shift.shift_status}`}>
                                      {shift.shift_status === 'on_time' && <CheckCircle size={14} />}
                                      {shift.shift_status === 'late' && <AlertCircle size={14} />}
                                      {shift.shift_status === 'early' && <Clock size={14} />}
                                      {shift.shift_status?.replace('_', ' ')}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="empty-state">
                              <Clock size={48} />
                              <h4>No Attendance Records</h4>
                              <p>No shift history available for this staff member yet.</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </Tab>
                  )}

                  {/* Activity Log Tab */}
                  <Tab eventKey="activity" title={
                    <span className="tab-title">
                      <Activity size={16} />
                      Activity Log
                    </span>
                  }>
                    <div className="tab-content-area">
                      <div className="empty-state">
                        <Activity size={48} />
                        <h4>Activity History</h4>
                        <p>Activity tracking and detailed logs will be available here soon</p>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <ConfirmActionModal
        show={showSuspendModal}
        onHide={() => setShowSuspendModal(false)}
        onConfirm={handleSuspendConfirm}
        title="Suspend Staff Member"
        message={
          <div>
            <p>Are you sure you want to suspend <strong>{user?.first_name} {user?.last_name}</strong>?</p>
            <p className="mt-2">They will lose access but can be reactivated later. All attendance records will be preserved.</p>
          </div>
        }
        confirmText="Suspend"
        type="warning"
        loading={actionLoading}
      />

      <ConfirmActionModal
        show={showReactivateModal}
        onHide={() => setShowReactivateModal(false)}
        onConfirm={handleReactivateConfirm}
        title="Reactivate Staff Member"
        message={
          <div>
            <p>Reactivate <strong>{user?.first_name} {user?.last_name}</strong>?</p>
            <p className="mt-2">They will regain access with their previous role and permissions.</p>
          </div>
        }
        confirmText="Reactivate"
        type="success"
        loading={actionLoading}
      />

      <ConfirmActionModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Remove Staff Member"
        message={
          <div>
            <p>Are you sure you want to permanently remove <strong>{user?.first_name} {user?.last_name}</strong>?</p>
            <p className="mt-2 text-danger"><strong>This action cannot be undone.</strong> All attendance records and data will be permanently deleted.</p>
          </div>
        }
        confirmText="Remove Permanently"
        type="danger"
        loading={actionLoading}
      />
    </>
  );
}

// Helper function
function getRoleDescription(role) {
  const descriptions = {
    admin: 'Full access to all organization features and settings. Can manage users, access codes, and view all analytics.',
    manager: 'Can manage staff, access codes, view logs and analytics, and handle day-to-day operations.',
    security: 'Focused on security operations including code validation, emergency response, and monitoring.',
    staff: 'Clock in/out capabilities, break management, and basic access code validation. Limited administrative access.',
    member: 'Basic access to validate codes and view logs.',
  };
  return descriptions[role] || 'Standard member access';
}